<template>
  <div>
    <div class="columns">
      <div class="map">
        <gmap-map
          :center="center"
          class="googleMap" ref="mapRef"
          @zoom_changed="updateZoom($event)"
          :zoom="zoomCarto">
            <gmap-marker
              v-for="(m, index) in getMarkerFaceLC"
              :key="index + 'faceLc'"
              :position="m.position"
              :icon="m.icon"
              @click="selectMarker(m)">
            </gmap-marker>
            <gmap-marker
              v-for="(m, index) in getMarkerPanneauNumerique"
              :key="index + 'faceNum'"
              :position="m.position"
              :icon="m.icon"
              @click="selectMarker(m)">
            </gmap-marker>
            <gmap-marker
              v-for="(m, index) in getMarkerFaceReseauxLc"
              :key="index + 'faceReseauLc'"
              :position="m.position"
              :icon="m.icon"
              @click="selectMarkerReseaux(m)">
            </gmap-marker>
            <gmap-marker
              v-for="(m, index) in getMarkerFaceReseauxTempo"
              :key="index + 'faceReseauTempo'"
              :position="m.position"
              :icon="m.icon"
              @click="selectMarkerReseaux(m)">
            </gmap-marker>
            <gmap-marker
              v-for="(m, index) in getMarkerFaceReseauxNumerique"
              :key="index + 'faceReseauNum'"
              :position="m.position"
              :icon="m.icon"
              @click="selectMarkerReseaux(m)">
            </gmap-marker>
            <gmap-marker
              v-for="(m, index) in getMarkerFaceReseauxPerso"
              :key="index + 'faceReseauPerso'"
              :position="m.position"
              :icon="m.icon"
              @click="selectMarkerReseaux(m)">
            </gmap-marker>
        </gmap-map>
      </div>
      <b-modal v-model="modalDetail"
               v-if="selectMarkerFace"
               has-modal-card
               class="modal">
        <info-window-map :marker="markerSelected"
                         @closeInfoWindow="markerSelected=''"/>
      </b-modal>
      <b-modal v-model="modalDetailReseaux"
               v-if="selectMarkerFaceReseaux"
               has-modal-card
               class="modal">
        <info-window-map-reseaux :marker="markerSelected"
                         @closeInfoWindow="markerSelected=''"/>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/panier-mutation-type';
import { ZOOM_DEFAULT_LC,
  PANNEAUX_FROM_VENTES_LC,
  PANNEAUX_FROM_VENTES_NUMERIQUES,
  FACES_FROM_VENTES_RESEAUX } from '@/configuration/carteConf';
import infoWindowMap from '@/components/creationOpportunite/panier/infoWindowMap';
import infoWindowMapReseaux from '@/components/creationOpportunite/panier/infoWindowMapReseaux';
import fromTypeToMarkers from '@/services/catalogue/fromTypeToMarkers';

const Panier = createNamespacedHelpers('panier');
const User = createNamespacedHelpers('user');

export default {
  name: 'app-map',
  props: {
    tabValue: Number,
    produits: Object,
  },
  components: {
    infoWindowMap,
    infoWindowMapReseaux,
  },
  data() {
    return {
      circleBounds: '',
      modalDetail: false,
      modalDetailReseaux: false,
      markerSelected: null,
      selectMarkerFace: false,
      selectMarkerFaceReseaux: false,
      getMarkerFaceLC: [],
      getMarkerPanneauNumerique: [],
      getMarkerFaceReseauxLc: [],
      getMarkerFaceReseauxTempo: [],
      getMarkerFaceReseauxNumerique: [],
      getMarkerFaceReseauxPerso: [],
    };
  },
  computed: {
    ...Panier.mapGetters({
      getZoomCarto: 'zoomCarto',
    }),
    ...User.mapGetters({
      getAfficherAzimut: 'afficherAzimut',
    }),
    zoomCarto: {
      get() {
        return ZOOM_DEFAULT_LC;
      },
      set(value) {
        this.setZoomCarto(value);
      },
    },
    center() {
      if (this.getMarkerFaceLC.length) {
        return this.getMarkerFaceLC[0].position;
      }
      if (this.getMarkerPanneauNumerique.length) {
        return this.getMarkerPanneauNumerique[0].position;
      }
      if (this.getMarkerFaceReseauxLc.length) {
        return this.getMarkerFaceReseauxLc[0].position;
      }
      if (this.getMarkerFaceReseauxTempo.length) {
        return this.getMarkerFaceReseauxTempo[0].position;
      }
      if (this.getMarkerFaceReseauxNumerique.length) {
        return this.getMarkerFaceReseauxNumerique[0].position;
      }
      if (this.getMarkerFaceReseauxPerso.length) {
        return this.getMarkerFaceReseauxPerso[0].position;
      }
      const myLatLng = { lat: 0, lng: 0 };
      return myLatLng;
    },
  },
  watch: {
    tabValue() {
      this.autoZoom();
    },
  },
  methods: {
    ...Panier.mapMutations({
      setZoomCarto: types.SET_ZOOM_CARTO,
    }),
    updateZoom($event) {
      this.zoomCarto = $event;
    },
    async autoZoom() {
      await this.$refs.mapRef.$mapPromise;
      this.fitBounds();
    },
    fitBounds() {
      const latlngbounds = new google.maps.LatLngBounds();
      for (let i = 0; i < this.getMarkerFaceLC.length; (i += 1)) {
        latlngbounds.extend(this.getMarkerFaceLC[i].position);
      }
      for (let i = 0; i < this.getMarkerPanneauNumerique.length; (i += 1)) {
        latlngbounds.extend(this.getMarkerPanneauNumerique[i].position);
      }
      for (let i = 0; i < this.getMarkerFaceReseauxLc.length; (i += 1)) {
        latlngbounds.extend(this.getMarkerFaceReseauxLc[i].position);
      }
      for (let i = 0; i < this.getMarkerFaceReseauxTempo.length; (i += 1)) {
        latlngbounds.extend(this.getMarkerFaceReseauxTempo[i].position);
      }
      for (let i = 0; i < this.getMarkerFaceReseauxNumerique.length; (i += 1)) {
        latlngbounds.extend(this.getMarkerFaceReseauxNumerique[i].position);
      }
      for (let i = 0; i < this.getMarkerFaceReseauxPerso.length; (i += 1)) {
        latlngbounds.extend(this.getMarkerFaceReseauxPerso[i].position);
      }
      this.$refs.mapRef.fitBounds(latlngbounds);
    },
    selectMarker(marker) {
      this.selectMarkerFace = !this.selectMarkerFace;
      this.modalDetail = true;
      this.markerSelected = marker;
    },
    selectMarkerReseaux(marker) {
      this.selectMarkerFaceReseaux = !this.selectMarkerFaceReseaux;
      this.modalDetailReseaux = true;
      this.markerSelected = marker;
    },
    genererMarkerAllProduits() {
      if (this.produits.panneauxLc.length > 0) {
        this.getMarkerFaceLC = fromTypeToMarkers(PANNEAUX_FROM_VENTES_LC,
          this.produits.panneauxLc, this.getAfficherAzimut);
      }
      if (this.produits.panneauxNumeriques.length > 0) {
        this.getMarkerPanneauNumerique = fromTypeToMarkers(PANNEAUX_FROM_VENTES_NUMERIQUES,
          this.produits.panneauxNumeriquesum, this.getAfficherAzimut);
      }
      if (this.produits.reseauxLc.length > 0) {
        const allFaces = [];
        this.produits.reseauxLc.forEach((reseau) => {
          const faces = reseau.listeFaces;
          faces.forEach((face) => {
            if (face.latitude !== 0 && face.longitude !== 0
              && Math.trunc(face.latitude) > 0
              && Math.trunc(face.longitude) > 0) {
              face.selected = reseau.selected;
              if (reseau.couleur) {
                face.color = reseau.couleur;
              }
              face.libelleReseau = reseau.libelle;
              allFaces.push(face);
            }
          });
        });
        this.getMarkerFaceReseauxLc = fromTypeToMarkers(FACES_FROM_VENTES_RESEAUX,
          allFaces, this.getAfficherAzimut);
      }
      if (this.produits.reseauxTempo.length > 0) {
        const allFaces = [];
        this.produits.reseauxTempo.forEach((reseau) => {
          const faces = reseau.listeFaces;
          faces.forEach((face) => {
            if (face.latitude !== null && face.longitude !== null
              && face.latitude !== 0 && face.longitude !== 0) {
              face.selected = reseau.selected;
              if (reseau.couleur) {
                face.color = reseau.couleur;
              }
              face.libelleReseau = reseau.libelle;
              allFaces.push(face);
            }
          });
        });
        this.getMarkerFaceReseauxTempo = fromTypeToMarkers(FACES_FROM_VENTES_RESEAUX,
          allFaces, this.getAfficherAzimut);
      }
      if (this.produits.reseauxNumeriques.length > 0) {
        const allFaces = [];
        this.produits.reseauxNumeriques.forEach((reseau) => {
          const faces = reseau.listeFaces;
          faces.forEach((face) => {
            if (face.latitude !== 0 && face.longitude !== 0
                && Math.trunc(face.latitude) > 0
                && Math.trunc(face.longitude) > 0) {
              face.selected = reseau.selected;
              if (reseau.couleur) {
                face.color = reseau.couleur;
              }
              face.libelleReseau = reseau.libelle;
              allFaces.push(face);
            }
          });
        });
        this.getMarkerFaceReseauxNumerique = fromTypeToMarkers(FACES_FROM_VENTES_RESEAUX,
          allFaces, this.getAfficherAzimut);
      }
      if (this.produits.reseauxPersonnalise.length > 0) {
        const markers = [];
        this.produits.reseauxPersonnalise.forEach(reseau => {
          const facesLc = reseau.produitsWithAllData
            .filter(face => face.typeProduit === PANNEAUX_FROM_VENTES_LC)
            .map(el => el.dataProduit);
          const markerFaceLc = fromTypeToMarkers(PANNEAUX_FROM_VENTES_LC,
            facesLc, this.getAfficherAzimut);
          const facesNum = reseau.produitsWithAllData
            .filter(face => face.typeProduit === PANNEAUX_FROM_VENTES_NUMERIQUES)
            .map(el => el.dataProduit);
          const markerFaceNum = fromTypeToMarkers(PANNEAUX_FROM_VENTES_NUMERIQUES,
            facesNum, this.getAfficherAzimut);
          const facesReseaux = reseau.produitsWithAllData
            .filter(face => face.typeProduit === FACES_FROM_VENTES_RESEAUX)
            .map(el => el.dataProduit);
          const markerFaceReseau = fromTypeToMarkers(FACES_FROM_VENTES_RESEAUX,
            facesReseaux, this.getAfficherAzimut);
          const tempTab = markerFaceLc.concat(markerFaceNum);
          markers.push(...tempTab.concat(markerFaceReseau));
        });
        this.getMarkerFaceReseauxPerso = markers;
      }
    },
  },
  mounted() {
    this.autoZoom();
    this.genererMarkerAllProduits();
  },
};

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/mesOpportunites/detail/carte.vue